<template>
  <div id="app">
    <!-- <Header :bgStyle="moudleSetting&&moudleSetting.header"></Header> -->
    <router-view />
    <!-- <Footer :bgStyle="moudleSetting&&moudleSetting.footer"></Footer> -->
  </div>
</template>

<script>
// import Header from "@/layouts/Header";
// import Footer from "@/layouts/Footer";
export default {
  name: "App",
  components: {
    // Header,
    // Footer,
  },
  data() {
    return {
      moudleSetting: {},
    };
  },
  created() {
    // this.getHeaderSetting();
  },
  methods: {
    getHeaderSetting() {
      let params = {
        tenant: this.$store.getters.tenantId,
      };
      this.$http
        .get(window.CONFIG.HOMEPAGE_HEADER_FOOTER_SETTING, { params })
        .then((res) => {
          if (res.success && res.data.list) {
            this.moudleSetting = JSON.parse(
              res.data.list && res.data.list.config
            );
          }
        });
    },
  },
};
</script>

<style>
@import url("style/index.scss");
.icon {
  width: 40px;
  height: 40px;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue